import i18next from 'i18next';
import {
  THeader,
  TTableBody,
  TTableRow
} from '../../../shared_components/vrr_table/types';
import React, { BaseSyntheticEvent } from 'react';
import { TBrandRow } from '../types';
import { Input } from 'reactstrap';
import { TBrandsAPI } from '../../../shared_components/vrr_dropdown/types';

export const prepareHeader = (
  onChangeAction?: (isChecked: boolean) => void
): THeader['element'][] => {
  return [
    {
      id: 'brand_id',
      component: (
        <p>
          {i18next
            .t('connected_brand.brand_table.header.brand_id')
            .toUpperCase()}
        </p>
      )
    },
    {
      id: 'brand_name',
      component: (
        <p>
          {i18next
            .t('connected_brand.brand_table.header.brand_name')
            .toUpperCase()}
        </p>
      )
    },
    {
      id: 'status',
      component: (
        <p className="brands-table-header-status">
          <Input
            id={`brands-table-all`}
            type="checkbox"
            className="brands-table-input"
            onClick={(e: BaseSyntheticEvent) => {
              if (onChangeAction) onChangeAction(e.target.checked);
            }}
          />
          {i18next.t('connected_brand.brand_table.header.status').toUpperCase()}
        </p>
      )
    }
  ];
};

export const prepareLine = (brand: {
  brand_id: string;
  brand_name: string;
  status: string;
}): TBrandRow[] => {
  const header = prepareHeader();
  return Object.values(brand)?.map((cell, index) => ({
    headerId: header[index].id,
    rowId: brand.brand_id.toString(),
    value: cell
  }));
};

const getLine = (
  line: TBrandRow[],
  currentBrand?: string,
  onChangeAction?: (value: string, isChecked: boolean) => void
): TTableRow['cellElements'] => {
  const newLine = [];
  line.forEach((cell) => {
    if (cell.headerId !== 'status') {
      newLine.push({
        headerId: cell.headerId,
        id: cell.rowId,
        component: (
          <label
            className="brands-table-value"
            htmlFor={`brands-table-${line[0].rowId}`}
          >
            <span>{cell.value}</span>
          </label>
        ),
        value: cell.value
      });
    }
  });
  newLine.push({
    headerId: 'checkbox',
    id: line[0].rowId,
    component: (
      <Input
        id={`brands-table-${line[0].rowId}`}
        type="checkbox"
        disabled={currentBrand === line[0].value}
        checked={line[2].value === 'displayed'}
        className="brands-table-input"
        onClick={(e: BaseSyntheticEvent) => {
          if (onChangeAction) onChangeAction(line[0].value, e.target.checked);
        }}
      />
    ),
    value: ''
  });

  return newLine;
};
export const prepareBody = (
  brands?: TBrandsAPI[],
  currentBrand?: string,
  onChangeAction?: (value: string, isChecked: boolean) => void
): TTableBody['rowElements'] => {
  const newBody: TTableBody['rowElements'] = [];
  brands?.forEach((brand) => {
    const line = prepareLine({
      brand_id: brand.brand_id.toString(),
      brand_name: brand.brand_name,
      status: brand.status
    });
    newBody.push(getLine(line, currentBrand, onChangeAction));
  });

  return newBody;
};
